import type { ProductPipelineMigrate } from './productShared';

export const PIPELINE_MIGRATE: ProductPipelineMigrate = {
  kicker: '- Next in the pipeline',
  title: 'Breakdown is the start. Memory is what holds it together.',
  body: 'Once Rhapsody has your shot plan, the Project Memory Graph locks every character, wardrobe detail, location, and mood across the whole cut — and the Verifier proves it on every shot.',
  ctaLabel: 'AI Video Continuity',
  ctaTo: '/product/ai-video-continuity',
} as const;
